import { Tab, TabGroup, TabList } from "@headlessui/react"
import { useContext } from "react"
import { classNames } from "../lib"
import { HelpModalContext } from "./Contexts"
import { NavigationItem } from "./MenuNavigation"

const SubNav = () => {
  const { setIsOpen: setOpenHelp } = useContext(HelpModalContext)
  const pageType = document.querySelector<HTMLElement>("[data-type]")?.dataset.type ?? ""
  const navigation: NavigationItem[] = [
    { label: "About", href: "/index.html" },
    { label: "Digital Access", href: "/digital-access.html" },
    { label: "Translation", href: "/translation.html" },
    { label: "Pre-Order Printed Bibles", href: "/pre-order.html" },
    {
      label: "Help",
      href: "",
      onClick: evt => {
        if (evt) {
          evt.preventDefault()
          evt.stopPropagation()
          evt.currentTarget.blur()
        }
        setOpenHelp(true)
      },
    },
  ]
  const currentPage = navigation.findIndex(n => n.label.toLowerCase() === pageType)

  return (
    <TabGroup
      as="div"
      defaultIndex={currentPage}
      selectedIndex={currentPage}
      onChange={index => {
        const link = navigation[index]

        if (link.onClick) {
          link.onClick()
        } else {
          // @ts-expect-error not sure how to type this
          window.location = link.href
        }
      }}
      manual
    >
      <TabList className="flex flex-wrap items-center justify-center space-x-3 p-1 text-center sm:space-x-4">
        {navigation.map((link, index) => (
          <Tab
            as="a"
            key={link.label}
            href={link.href}
            className={({ selected }) =>
              classNames(
                "rounded-lg p-2 text-sm font-medium whitespace-nowrap",
                "ring-white/60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                selected
                  ? "bg-white shadow text-sky-700"
                  : "text-blue-100 hover:bg-white/[0.12] hover:text-white",
                navigation.length - 1 === index ? "" : ""
              )
            }
            onClick={
              link.onClick
                ? evt => {
                    link.onClick && link.onClick(evt)
                  }
                : undefined
            }
          >
            {link.label}
          </Tab>
        ))}
      </TabList>
    </TabGroup>
  )
}

export default SubNav
